import _ from 'lodash';
import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import FormSelect from "../form/FormSelect";
import { fleetToManagerUserId } from '../../libs/common';

class FleetPicker extends PureComponent {
	render () {
		const options = _.sortBy(_.keys(fleetToManagerUserId)).map(fleet => {
			return {
				value : fleet,
				display : fleet,
			};
		});

		return (
			<FormSelect
				{...this.props}
				options={options}
			/>
		);
	}
}

FleetPicker.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,

	classes : PropTypes.object,
	helpText : PropTypes.string,
};

FleetPicker.defaultProps =  {
	label : 'Ticket Schema',
};

export default FleetPicker;
